import "./TeethClenchingBotox.module.css";
import Header from "@/reusable_sections/Header";
import HeroImage from "./sections/HeroImage";
import EndoskopiHakkinda from "./sections/EndoskopiHakkinda";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Projects from "./sections/Projects";
import Footer from "@/reusable_sections/Footer";
export default function TeethClenchingBotoxPage() {
  return <div>
      <Header />
      <HeroImage />
      <EndoskopiHakkinda />
      <Projects />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}